import React from "react";

import i18n from "../i18n";
const tr = i18n.t.bind(i18n);
export default function NotificationPrompt({ onEnable, onEnabled, onDismiss }) {
  const [busy, setBusy] = React.useState(false);
  async function handleEnable() {
    try {
      setBusy(true);
      const token = await onEnable?.();
      if (token) onEnabled?.(token);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      role="region"
      aria-label={tr('Enable notifications')}
      aria-live="polite"
      style={bar}
    >
      <div style={inner}>
        <div style={msg}>
          <span>{tr('Real-time service notifications:')}</span>
        </div>
        <div style={actions}>
          <button onClick={handleEnable} disabled={busy} style={primaryBtn}>
            {busy ? "Enabling…" : "Enable"}
          </button>
          <button onClick={() => onDismiss?.()} style={ghostBtn}>{tr('Not now')}</button>
        </div>
      </div>
    </div>
  );
}

const bar = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 9999,
  background: "#111827", // slate-900
  color: "#fff",
  padding: "8px 12px",
  paddingTop: "calc(8px + env(safe-area-inset-top, 0px))",
  boxShadow: "0 2px 10px rgba(0,0,0,.2)",
};
const inner = {
  maxWidth: 1200,
  margin: "0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
};
const msg = { display: "flex", alignItems: "center", gap: 8, fontSize: 14, lineHeight: 1.2 };
const actions = { display: "flex", alignItems: "center", gap: 8 };
const primaryBtn = {
  padding: "6px 12px",
  borderRadius: 8,
  border: 0,
  background: "#2563eb",
  color: "#fff",
  cursor: "pointer",
};
const ghostBtn = {
  padding: "6px 10px",
  borderRadius: 8,
  border: "1px solid #d1d5db",
  background: "#fff",
  color: "#111827",
  cursor: "pointer",
};